import classnames from "classnames";
import React from "react";

import * as styles from "./Quote.module.css";

const Quote = ({
  className,
  content,
  author,
  authorTitle,
  type,
  lightOnDark,
  quoteColor,
  quoteColorAlt,
  largeText,
  largerText,
  largestText,
  quoteLeftPadding,
  alignCenter,
  fancyQuote,
  fancyAvatar,
  additional,
  mobileStyle,
  avatar,
  mdContent
}) => {
  const classes = classnames(styles.quote, className, {
    [styles.showcaseImage]: type === "showcaseImage",
    [styles.lightOnDark]: lightOnDark,
    [styles.quoteColor]: quoteColor,
    [styles.quoteColorAlt]: quoteColorAlt,
    [styles.quoteLeftPadding]: quoteLeftPadding,
    [styles.textAlignCenter]: alignCenter,
    [styles.reorderFancyAvatar]: fancyAvatar,
    [styles.mobileStyle]: mobileStyle,
  });

  const blockquoteClasses = classnames(styles.innerQuoteContent, {
    ["h2Smaller"]: largeText,
    ["h2"]: largerText,
    ["h1"]: largestText
  })

  return (
    <div className={classes}>
      {fancyQuote && <div className={styles.fancyQuote} style={{ backgroundColor: fancyQuote || red }} />}
      <div className={styles.quoteContent}>
        {content && <blockquote className={blockquoteClasses}>{content}</blockquote>}
        {mdContent && (
          <div className={`${styles.mdContent}`}>{mdContent}</div>
        )}
        <div className={`${styles.author} smallestBodyText`}>
          {avatar && <div className={styles.avatar}>{avatar}</div>}
          {fancyAvatar && <div className={styles.fancyAvatar} style={{ backgroundColor: fancyAvatar || red }} />}
          <div className={styles.authorText}>
            <div className="fontWeightBold">{author && author}</div>
            <div>{authorTitle && authorTitle}</div>
          </div>
        </div>
        {additional && additional}
      </div>
    </div>
  );
};

export default Quote;
